import { render, staticRenderFns } from "./Newest.vue?vue&type=template&id=90b26d36&scoped=true&"
import script from "./Newest.vue?vue&type=script&lang=ts&"
export * from "./Newest.vue?vue&type=script&lang=ts&"
import style0 from "./Newest.vue?vue&type=style&index=0&id=90b26d36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b26d36",
  null
  
)

export default component.exports